import i18n from "~Shared/locales/i18n"

/**
 * @returns currently active locale (only base language e.g. if locale is en-US this method returns en)
 */
export const getLanguageCode = () => i18n.language.substring(0, 2) as "en" | "de"
